<template xmlns="http://www.w3.org/1999/html">
  <div style="width: 100vw;height: 100vh;display: flex;justify-content: center;align-items: center;">
    <div id="background" class="bg">
      <img src="/static/images/qh/top-bg.png" alt="" style="width: 100%;position: absolute;top:0vh" />
      <img src="/static/images/qh/pay3m.png" alt="" style="width: 65%;position: absolute;top:3vh" />
      <img src="/static/images/qh/banner.png" alt="" style="width: 90%;position: absolute;top:11vh" />


      <div
        style="width: 100%;position: absolute;top:32vh;display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <img src="/static/images/qh/win2.png" style="width: 100%;position: absolute;top: 0;z-index: 1;" />


        <span style="font-size: 4vw;font-weight: bold;z-index: 2;margin-top: 20vh;">欢迎进入绮涵防伪认证</span>
        <span style="font-size: 4vw;font-weight: bold;z-index: 2;margin-top: 1.5vh;">点击"进入查询"查看防伪码</span>


        <img src="/static/images/qh/jrcx.png" @click="getAuth" alt=""
          style="width: 40%;margin-top: 3vh;height: auto;z-index: 2;" />

      </div>


    </div>
  </div>

</template>


<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>

<style scoped>
@media (max-width: 600px) {
  .bg {
    width: 100vw;
    position: fixed;
    background: url(/static/images/qh/bg.png) no-repeat;
    background-attachment: fixed;
    background-position: bottom;
    background-size: cover;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    align-items: center;
  }
}

/* 针对中等屏幕设备 */
@media (min-width: 601px) and (max-width: 1200px) {
  .bg {
    width: 60vw;
    position: fixed;
    background: url(/static/images/qh/bg.png) no-repeat;
    background-attachment: fixed;
    background-position: bottom;
    background-size: cover;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    align-items: center;
  }
}

/* 针对大屏幕设备 */
@media (min-width: 1201px) {
  .bg {
    width: 60vw;
    position: fixed;
    background: url(/static/images/qh/bg.png) no-repeat;
    background-attachment: fixed;
    background-position: bottom;
    background-size: cover;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    align-items: center;
  }
}
</style>
<script>
import { getWechatAuth } from '../../api/api'
export default {
  data() {
    return {
      authCode: "",
    }
  },
  methods: {
    getAuth() {
      const params = this.$route.query
      const code = params.c
      const url = window.location.origin + "/qh/index?c=" + code;
      getWechatAuth(url, "wx9226bf7d87cb47e5", 1).then(res => {
        const data = res.data;
        window.location.href = data;
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted: function () {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QiHan/Loading.vue